const {Component} = require("react");
const PropTypes = require("prop-types");
const ReactTags = require("react-tag-autocomplete");
const {pluckKeysExcept} = require("helpers/object");
const {methodNotImplemented} = require("helpers/errors");
const React = require('react')

const Tag = (props) => (
    React.createElement( 'button', { type: 'button', className: props.classNames.selectedTag, title: 'Click to remove tag', onClick: props.onDelete },
		(typeof(props.tag.image_url) !== 'undefined')?React.createElement( 'img', { src: props.tag.image_url }):'',
        React.createElement( 'span', { className: props.classNames.selectedTagName }, props.tag.name)
    )
);

class ReactTagsOverride extends ReactTags {
	handleClick (e) {
	}
}

class Tags extends Component {

	static get propTypes() {
		return {
			name: PropTypes.string,
			value: PropTypes.array,
			defaultValue: PropTypes.array,
			pool: PropTypes.array,
			placeholder: PropTypes.string,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			pool: [],
			placeholder: "Tilføj ny"
		}
	}

	constructor(props) {
		super(props);
console.log(props);
		this.state = {
			value: props.value || props.defaultValue || []
		};
	}

	componentWillReceiveProps(props) {
		if (props.value instanceof Array) {
			this.setState({value: props.value});
		}
	}

	get inputProps() {
		return pluckKeysExcept(this.props, Object.keys(this.constructor.propTypes).concat(["className", "tag"]));
	}

	get className() {
		let classList = ["tags"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	get pool() {
		const values = this.state.value.map(tag => tag.id);
		return this.props.pool.filter(tag => values.indexOf(tag.id) === -1);
	}

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.value);
		}
	};

	onAdd = (tag) => {
		this.setState(state => {
			state.value.push(tag);
			return state;
		}, this.handleChange);
	};

	onDelete = (index) => {
		this.setState(state => {
			state.value.splice(index, 1);
			return state;
		}, this.handleChange);
	};

	renderTags() {
		return (
			<ReactTagsOverride placeholder={this.props.placeholder} autofocus={false} tagComponent={Tag}
								 tags={this.state.value} suggestions={this.pool}
								 handleDelete={this.onDelete} handleAddition={this.onAdd}/>
		);
	}

	render() {
		throw methodNotImplemented("render");
	}

	/////////////////////////////////
	// API
	/////////////////////////////////

	get value() {
		return this.state.value;
	}

}

module.exports = Tags;



// WEBPACK FOOTER //
// ./resources/js/components/abstract/Tags.js